import { render, staticRenderFns } from "./showCollapse-editorvue.vue?vue&type=template&id=229544d8&scoped=true"
import script from "./showCollapse-editorvue.vue?vue&type=script&lang=js"
export * from "./showCollapse-editorvue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229544d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('229544d8')) {
      api.createRecord('229544d8', component.options)
    } else {
      api.reload('229544d8', component.options)
    }
    module.hot.accept("./showCollapse-editorvue.vue?vue&type=template&id=229544d8&scoped=true", function () {
      api.rerender('229544d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/property-editor/showCollapse-editorvue.vue"
export default component.exports